import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import RowActions, {
  editAction,
  deleteAction,
} from "components/Table/RowActions";
import Constants from "../../core/Constants";
import SelectRow from "../../components/Select/SelectRow";
import { Scopes } from "../../shared/scopes.enum";
import { JobStatus } from "../../shared/job-statuses.enum";
import { formatMileage } from "../../shared/mileage";

class MerchantJobList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      globalFilter: "",
      startDateFilter: null,
      endDateFilter: null,
      isModalOpen: false,
      selectedJob: null,
      canWrite: false,
      userAllowedJobStatuses: [],
    };

    this.engine = new RequestEngine();
  }
  componentDidMount() {
    const merchantIdFromStorage = sessionStorage.getItem("merchantId");
    const { selectedMerchant } = this.props.match.params;
    const userJobStatusesString =
      sessionStorage.getItem("allowedJobStatuses") || "";
    const userAllowedJobStatuses = userJobStatusesString
      .split(",")
      .map((status) => status.trim());
    const canWrite =
      this.hasPermission([Scopes.MERCHANTS_JOBS_WRITE]) &&
      userAllowedJobStatuses.length > 0 &&
      userAllowedJobStatuses.includes(JobStatus.REGISTRATION);

    this.setState({ canWrite, userAllowedJobStatuses });

    if (merchantIdFromStorage) {
      this.setState({ selectedMerchant: merchantIdFromStorage }, this.callPage);
      this.fetchMerchants();
    } else if (selectedMerchant !== ":selectedMerchant") {
      this.setState({ selectedMerchant }, this.callPage);
      this.fetchMerchants();
    } else {
      this.fetchMerchants();
    }
  }

  fetchMerchants = async () => {
    const response = await this.engine.getItem("merchants");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        merchants: response.data.items.map((merchant) => ({
          value: merchant.id,
          label: merchant.name,
        })),
      });
      if (this.state.merchants.length === 1) {
        this.setState({
          selectedMerchant: this.state.merchants[0].value,
        });
        this.callPage();
      }
    }
  };

  toggleModal = (job, items) => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
      selectedJob: job,
      myItems: items,
    });
  };

  async handleDelete(valueid) {
    const { selectedMerchant } = this.state;
    if (window.confirm(strings.confirmdelete)) {
      this.props.loadingAction(true);
      const result = await this.engine.deleteItem(
        `merchants/${selectedMerchant}/jobs`,
        valueid
      );
      if (result) {
        this.handlePage();
      }
      this.props.loadingAction(false);
    }
  }

  handleEdit(index, dataid) {
    const data = this.state.dataSource[index].data;
    const itemsObject = this.state.dataSource[index].itemsObject;
    const { selectedMerchant } = this.state;
    this.props.history.push({
      pathname: `/admin/merchant/${selectedMerchant}/jobs/edit/${dataid}`,
      data,
      itemsObject,
    });
  }
  handleMerchantSelect = (event) => {
    const selectedMerchant = event.target.value;
    this.setState({ selectedMerchant }, () => {
      this.props.history.push(`/admin/merchant/${selectedMerchant}/jobs`);
      this.callPage();
    });
  };

  handleActions(index, item, items) {
    const { userAllowedJobStatuses, canWrite } = this.state;
    return (
      <RowActions
        actions={[
          editAction(
            () => this.handleEdit(index, item.id),
            canWrite && userAllowedJobStatuses.includes(item.status)
          ),
          deleteAction(
            () => this.handleDelete(item.id),
            canWrite && userAllowedJobStatuses.includes(item.status)
          ),
          {
            key: "information",
            icon: "fa fa-info-circle",
            label: strings.information,
            onClick: () => this.toggleModal(item, items),
          },
        ]}
      />
    );
  }

  async callPage() {
    const { selectedMerchant, userAllowedJobStatuses } = this.state;
    if (!selectedMerchant) return;
    if (userAllowedJobStatuses.length === 0) return;

    const pathname = `merchants/${selectedMerchant}/jobs`;

    try {
      const response = await this.engine.getItem(pathname);

      if (response && response.status === 200) {
        const jobData = response.data.items;

        // Fetch job items for each job
        const dataSource = await Promise.all(
          jobData.map(async (job, key) => {
            try {
              const itemsPath = `merchants/${selectedMerchant}/jobs/${job.id}/items`;

              // Fetch items for the current job
              const itemsResponse = await this.engine.getItem(itemsPath);

              const itemCodes = itemsResponse?.data?.map(
                (item) =>
                  `${item.merchantItem?.code} - ${item.merchantItem?.description}` ||
                  "No Code Available"
              );

              return {
                id: key,
                data: job,
                itemsObject: itemsResponse.data,
                customer: job.customer?.user?.firstName || "Unknown",
                worker: job.workers.map((worker) => worker.name ?? "Unknown"),
                merchant: job.merchant?.name || "Unknown",
                customerVehicle: job.customerVehicle?.model?.name || "N/A",
                status: strings[job.status],
                arrivalMileage: job.arrivalMileage,
                departureMileage: job.departureMileage,
                representative: job.representative,
                representativePhone: job.representativePhone,
                note: job.note,
                testDriveNotes: job.testDriveNotes,
                created: new Date(job.createdAt),
                items: itemCodes,
                images: job.images,

                actions: this.handleActions(key, job, itemCodes),
              };
            } catch (itemError) {
              console.error(
                `Error fetching items for job ${job.id}:`,
                itemError
              );
              return null;
            }
          })
        );

        this.setState({
          isLoading: false,
          dataSource: dataSource.filter((item) => item !== null),
        });
      } else {
        console.error("No jobs found or invalid response structure:", response);
        this.setState({ isLoading: false });
      }
    } catch (error) {
      console.error("Error fetching job data:", error);
      this.setState({ isLoading: false });
    }

    this.props.loadingAction(false);
  }

  handlePage() {
    this.props.loadingAction(true);
    this.callPage();
  }

  handleAdd = () => {
    const { selectedMerchant } = this.state;
    if (!selectedMerchant) {
      alert(strings.select + " " + strings.merchant);
      return;
    }
    this.props.history.push(`/admin/merchant/${selectedMerchant}/jobs/add`);
  };

  renderJobDetailsModal() {
    const { selectedJob, selectedMerchant } = this.state;

    if (!selectedJob) return null;

    const images = selectedJob.images || [];
    const items = this.state.myItems || [];

    return (
      <React.Fragment>
        <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>
            {strings.job + " " + strings.information}{" "}
            {`${selectedJob.customer?.user?.firstName} ${selectedJob.customer?.user?.lastName}` ||
              "Unknown"}
          </ModalHeader>
          <ModalBody>
            <div>
              <p>
                <strong>{strings.customer}:</strong>{" "}
                {selectedJob.customer?.user?.firstName || "Unknown"}
              </p>
              <strong>{strings.worker}:</strong>
              {(selectedJob.workers || []).length > 0 ? (
                <ul>
                  {selectedJob.workers.map((worker, idx) => (
                    <li key={idx}>
                      {`${worker.name} - ${worker.title}` ?? "Unknown"}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>{strings.no + " " + strings.worker}</p>
              )}
              <p>
                <strong>{strings.merchant}:</strong>{" "}
                {selectedJob.merchant?.name || "Unknown"}
              </p>
              <p>
                <strong>{strings.customervehicle}:</strong>{" "}
                {selectedJob.customervehicle?.model?.name || "N/A"}
              </p>
              <p>
                <strong>{strings.status}:</strong>{" "}
                {strings[selectedJob.status] || "N/A"}
              </p>
              <p>
                <strong>{strings.arrivalmileage}:</strong>{" "}
                {formatMileage(selectedJob.arrivalMileage)}
              </p>
              <p>
                <strong>{strings.departureMileage}:</strong>{" "}
                {formatMileage(selectedJob.departureMileage) || "N/A"}
              </p>
              <p>
                <strong>{strings.driver}:</strong>{" "}
                {selectedJob.representative || "Unknown"}
              </p>
              <p>
                <strong>{strings.driverphonenumber}:</strong>{" "}
                {selectedJob.representativePhone || "N/A"}
              </p>
              <p>
                <strong>{strings.note}:</strong> {selectedJob.note || "N/A"}
              </p>
              <p>
                <strong>{strings.testdrivenote}:</strong>{" "}
                {selectedJob.testDriveNotes || "N/A"}
              </p>
              <p>
                <strong>{strings.created}:</strong>{" "}
                {selectedJob.createdAt
                  ? new Date(selectedJob.createdAt).toLocaleDateString()
                  : "N/A"}
              </p>

              <h5>{strings.items}:</h5>
              {items.length > 0 ? (
                <ul>
                  {items.map((item, idx) => (
                    <li key={idx}>{item || "No Code Available"}</li>
                  ))}
                </ul>
              ) : (
                <p>{strings.no + " " + strings.items}</p>
              )}

              <h5>{strings.images}:</h5>
              <div>
                {images.length > 0 ? (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      justifyContent: "flex-start",
                    }}
                  >
                    {images.map((image, index) => (
                      <div
                        key={index}
                        style={{
                          width: "200px",
                          height: "200px",
                          position: "relative",
                          overflow: "hidden",
                          borderRadius: "5px",
                        }}
                      >
                        <img
                          src={`${Constants.serverlink}api/v1/merchants/${selectedMerchant}/jobs/${image}`}
                          alt={`Job Item ${index + 1}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            window.open(
                              `${Constants.serverlink}api/v1/merchants/${selectedMerchant}/jobs/${image}`,
                              "_blank"
                            )
                          }
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>{strings.no + " " + strings.images}</p>
                )}
              </div>
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }

  render() {
    const { dataSource, isLoading, merchants, selectedMerchant, canWrite } =
      this.state;

    let columns = [
      {
        Header: strings.customer,
        accessor: "customer",
      },

      {
        Header: strings.merchant,
        accessor: "merchant",
      },
      {
        Header: strings.items,
        accessor: "items",
        Cell: ({ value }) =>
          Array.isArray(value) ? value.join(", ") : "No Items",
      },
      {
        Header: strings.status,
        accessor: "status",
      },
      {
        Header: `${strings.vehicle}  ${strings.arrivalmileage}`,
        accessor: "arrivalMileage",
        Cell: (row) => formatMileage(row.value),
      },
      {
        Header: strings.created,
        accessor: "created",
        Cell: (row) => row.value.toLocaleDateString(),
      },
      {
        Header: strings.actions,
        accessor: "actions",
        sortable: false,
        filterable: false,
      },
    ];

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4" className="pull-left"></CardTitle>
                  {canWrite && (
                    <>
                      <Button
                        color="primary"
                        className="pull-right"
                        onClick={() => this.handleAdd()}
                      >
                        {strings.add}
                      </Button>
                    </>
                  )}
                  <Button
                    className="hover-button pull-left"
                    onClick={() => this.callPage()}
                  >
                    {strings.refresh}
                  </Button>
                  {!sessionStorage.getItem("merchantId") &&
                    merchants.length !== 1 && (
                      <SelectRow
                        label={strings.merchant}
                        name="selectedMerchant"
                        defaultValue={selectedMerchant}
                        data={merchants}
                        changeInput={(e) => {
                          const selectedMerchant = e.value;
                          this.setState({ selectedMerchant }, () => {
                            this.props.history.push(
                              `/admin/merchant/${selectedMerchant}/branches`
                            );
                            this.callPage();
                          });
                        }}
                        placeholder={strings.select}
                      />
                    )}
                </CardHeader>
                <CardBody>
                  <ReactTable
                    previousText={strings.previous}
                    nextText={strings.next}
                    loadingText={strings.loading}
                    noDataText={strings.nodata}
                    pageText={strings.page}
                    data={dataSource}
                    defaultFilterMethod={this.filterCaseInsensitive}
                    filterable
                    loading={isLoading}
                    columns={columns}
                    defaultPageSize={10}
                    showPaginationTop={false}
                    showPaginationBottom
                    PaginationComponent={TablePagination}
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {this.renderJobDetailsModal()}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});
export default connect(null, mapDispatchToProps)(MerchantJobList);
